"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9207],{

/***/ 73650:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useAccordion = useAccordion;
exports.Accordion = Accordion;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3928));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(3498));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var __jsx = _react["default"].createElement;

function useAccordion() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sections = props.sections,
      _props$oneAtATime = props.oneAtATime,
      oneAtATime = _props$oneAtATime === void 0 ? false : _props$oneAtATime; // Hook uncontrolled right now

  var _useState = (0, _react.useState)(sections.map(function (s) {
    return s.isOpenAtInit || false;
  })),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var newSections = sections.map(function (section, index) {
    var open = function open() {
      var newIsOpen = (0, _toConsumableArray2["default"])(isOpen); //
      // if (oneAtATime) {
      //     newIsOpen = new Array(sections.length).fill(false);
      // }

      newIsOpen[index] = true;
      setOpen(newIsOpen);
    };

    var close = function close() {
      var newIsOpen = (0, _toConsumableArray2["default"])(isOpen);
      newIsOpen[index] = false;
      setOpen(newIsOpen);
    };

    var toggle = function toggle() {
      if (isOpen[index]) {
        close();
      } else {
        open();
      }
    };

    return {
      open: open,
      close: close,
      toggle: toggle,
      buttonProps: {
        onClick: function (_onClick) {
          function onClick() {
            return _onClick.apply(this, arguments);
          }

          onClick.toString = function () {
            return _onClick.toString();
          };

          return onClick;
        }(function () {
          toggle();

          if (sections.onClick) {
            onClick.apply(void 0, arguments);
          }
        }),
        selected: isOpen[index]
      },
      showHideProps: {
        isOpen: isOpen[index]
      }
    };
  });
  return {
    sections: newSections
  };
}

function AccordionSection(props) {}

function Accordion(props) {
  var children = props.children,
      controller = props.controller,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["children", "controller"]);
  children = _react["default"].Children.toArray(children);
  var sections = [];
  children.forEach(function (child, index) {
    if (child.type === AccordionSection) {
      var grandChildren = _react["default"].Children.toArray(child.props.children);

      var _child$props = child.props,
          isOpenAtInit = _child$props.isOpenAtInit,
          _restProps = (0, _objectWithoutProperties2["default"])(_child$props, ["isOpenAtInit"]);

      sections.push({
        button: grandChildren[0],
        showHide: grandChildren[1],
        headerAs: child.props.headerAs || "h6",
        isOpenAtInit: isOpenAtInit,
        props: _restProps
      });
    }
  });

  if (!controller) {
    controller = useAccordion((0, _objectSpread2["default"])({
      sections: sections.map(function (section) {
        return {
          isOpenAtInit: section.isOpenAtInit
        };
      })
    }, props));
  }

  var i = 0;
  return __jsx(_Box["default"], restProps, children.map(function (child, index) {
    if (child.type === AccordionSection) {
      var section = sections[i];
      var sectionController = controller.sections[i];
      i++;
      return __jsx(_Box["default"], (0, _extends2["default"])({}, section.props, {
        key: child.key || index
      }), __jsx(_Box["default"], {
        as: section.headerAs
      }, _react["default"].cloneElement(section.button, sectionController.buttonProps)), _react["default"].cloneElement(section.showHide, sectionController.showHideProps));
    }

    return child;
  }));
}

Accordion.Section = AccordionSection;
var _default = Accordion;
exports["default"] = _default;

/***/ }),

/***/ 7284:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _useToggleState = _interopRequireDefault(__webpack_require__(71604));

function Checkbox(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);
  var controller = (0, _useToggleState["default"])(props);

  var selectable = _react["default"].Children.only(children);

  selectable = _react["default"].cloneElement(selectable, (0, _objectSpread2["default"])({}, props, {
    selected: controller.value,
    onClick: function onClick() {
      controller.setValue(!controller.value);
    }
  }));
  return selectable;
} // TODO: accessibility


var _default = Checkbox;
exports["default"] = _default;

/***/ }),

/***/ 59799:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _Selectable = _interopRequireDefault(__webpack_require__(53910));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _index = __webpack_require__(79329);

var __jsx = _react["default"].createElement;
var defaults = {
  $root: function $root(_ref) {
    var focused = _ref.focused;
    return {
      display: "flex",
      flexDirection: "row"
    };
  }
};

function Checkbox() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var description = props.description,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["description"]);
  return __jsx(_Selectable["default"], restProps, function (state) {
    var sx = props.sx;

    if (typeof sx === "function") {
      sx = sx(state);
    }

    var _splitSx = (0, _index.splitSx)(sx),
        _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
        css = _splitSx2[0],
        customSx = _splitSx2[1];

    var labelStyles = customSx.$label || {};

    if (typeof labelStyles === "function") {
      labelStyles = labelStyles(state);
    }

    var labelContainerStyles = customSx.$labelContainer || {};

    if (typeof labelContainerStyles === "function") {
      labelContainerStyles = labelContainerStyles(state);
    }

    var descriptionStyles = customSx.$description || {};

    if (typeof descriptionStyles === "function") {
      descriptionStyles = descriptionStyles(state);
    }

    return __jsx(_Box["default"], {
      sx: [defaults.$root(state), css]
    }, __jsx(_Box["default"], {
      sx: {
        flex: "0 0 auto"
      }
    }, _react["default"].cloneElement((0, _objectSpread2["default"])({}, customSx.$checkmark), restProps)), __jsx(_Box["default"], {
      sx: (0, _objectSpread2["default"])({}, labelContainerStyles)
    }, __jsx(_Box["default"], {
      sx: (0, _objectSpread2["default"])({}, labelStyles)
    }, props.label), props.description && __jsx(_Box["default"], {
      sx: (0, _objectSpread2["default"])({}, descriptionStyles)
    }, props.description)));
  });
}

var _default = Checkbox;
exports["default"] = _default;

/***/ }),

/***/ 22040:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _react = _interopRequireDefault(__webpack_require__(34885));

var _Selectable = _interopRequireDefault(__webpack_require__(53910));

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _index = __webpack_require__(79329);

var __jsx = _react["default"].createElement;
var defaults = {
  $root: function $root(_ref) {
    var focused = _ref.focused;
    return {
      width: 20,
      height: 20,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };
  }
};

function Checkmark() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return __jsx(_Selectable["default"], props, function (state) {
    var sx = props.sx;

    if (typeof sx === "function") {
      sx = sx(state);
    }

    var _splitSx = (0, _index.splitSx)(sx),
        _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
        css = _splitSx2[0],
        customSx = _splitSx2[1];

    var iconStyles = customSx.$icon || {};

    if (typeof iconStyles === "function") {
      iconStyles = iconStyles(state);
    }

    return __jsx(_Box["default"], {
      sx: [defaults.$root(state), css]
    }, __jsx(_Box["default"], {
      as: "svg",
      viewBox: "0 0 14 14",
      focusable: "false",
      role: "presentation",
      sx: (0, _objectSpread2["default"])({
        display: "block",
        width: 12,
        height: 12
      }, iconStyles)
    }, __jsx("g", {
      fill: "currentColor"
    }, __jsx("polygon", {
      points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
    }))));
  });
}

var _default = Checkmark;
exports["default"] = _default;

/***/ }),

/***/ 71604:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _react = _interopRequireWildcard(__webpack_require__(34885));

// Toggle state is select state with 2 assumptions
// - options is [false, true]
// - allowEmpty doesn't make sense, it's always false
function filterProps(props) {
  var value = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["value", "defaultValue", "onChange"]);
  return restProps;
}

function useToggleState(props) {
  var value = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange; // UNCONTROLLED ONLY IF: value === "undefined"

  var isControlled = typeof value !== "undefined";

  var _useState = (0, _react.useState)(!!defaultValue),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var currentValue = isControlled ? !!value : internalValue;

  var setValue = function setValue(newVal) {
    newVal = !!newVal;

    if (newVal === currentValue) {
      return;
    }

    if (!isControlled) {
      setInternalValue(newVal);
    }

    if (onChange) {
      onChange(newVal);
    }
  };

  return {
    value: currentValue,
    setValue: setValue,
    reset: function reset() {
      setValue(false);
    }
  };
}

useToggleState.filterProps = filterProps;
var _default = useToggleState;
exports["default"] = _default;

/***/ }),

/***/ 81545:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Checkbox = _interopRequireDefault(__webpack_require__(7284));
var _Accordion = _interopRequireDefault(__webpack_require__(73650));
var _Button = _interopRequireDefault(__webpack_require__(96088));
var _ShowHide = _interopRequireDefault(__webpack_require__(2500));
var _Display = _interopRequireDefault(__webpack_require__(35572));
var _SideStickyMenu = _interopRequireDefault(__webpack_require__(95718));
var _CookieAgreementsProvider = __webpack_require__(2616);
var _LanguageProvider = __webpack_require__(8989);
var _setAgreementsCookie = _interopRequireDefault(__webpack_require__(56260));
var _isSalesmanagoEnabled = _interopRequireDefault(__webpack_require__(58592));
var _reactModal = _interopRequireDefault(__webpack_require__(34434));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LogoIcon = function LogoIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M20.841.27H.341v1.442h1.703c2.685 0 3.864 1.179 3.864 3.864v35.237c0 2.685-1.179 3.93-3.864 3.93H.34v1.375h19.256c16.832 0 24.168-11.92 24.168-23.579C43.765 11.274 36.953.271 20.84.271zm-1.375 44.145h-4.061c-2.161 0-3.144-1.048-3.144-3.21V1.975h7.205c12.378 0 17.487 10.741 17.487 21.155 0 10.414-4.978 21.286-17.487 21.286zM86.118 44.677c-2.227 0-3.471-.786-4.126-2.358L65.159.271h-1.964L46.886 41.99c-.458 1.18-1.31 2.686-4.388 2.686H41.45v1.441h14.278v-1.375H53.37c-2.292 0-3.34-.983-3.34-2.555 0-.655.13-1.31.393-2.03l3.21-8.45H71.12l3.274 8.45c.262.72.459 1.375.459 1.965 0 1.768-1.18 2.62-3.537 2.62h-2.292v1.375h18.208v-1.44h-1.114zm-31.7-15.064L62.212 8.72l8.122 20.893H54.418zM115.525.27H96.728v1.442h2.947c2.685 0 3.93 1.179 3.93 3.864v30.718c0 3.209-.393 6.484-2.62 8.842-1.638-3.603-4.585-4.978-6.812-4.978-2.161 0-3.668 1.244-3.668 2.947 0 2.162 3.079 3.734 6.681 3.734 5.633 0 12.706-3.734 12.706-15V5.577c0-2.685 1.179-3.864 3.865-3.864h1.768V.27zM156.59 44.677c-2.226 0-3.471-.786-4.126-2.358L135.632.271h-1.965l-16.309 41.72c-.458 1.18-1.31 2.686-4.388 2.686h-1.048v1.441H126.2v-1.375h-2.358c-2.292 0-3.34-.983-3.34-2.555 0-.655.131-1.31.393-2.03l3.209-8.45h17.488l3.275 8.45c.262.72.458 1.375.458 1.965 0 1.768-1.179 2.62-3.537 2.62h-2.292v1.375h18.208v-1.44h-1.114zm-31.7-15.064l7.794-20.893 8.122 20.893H124.89zM196.215 41.86l-4.061-8.317c-3.733-7.729-7.794-9.432-12.248-10.545 7.532-.524 14.606-4.52 14.606-11.724 0-5.895-4.716-11.003-14.737-11.003H160.65v1.44h1.703c2.685 0 3.864 1.18 3.864 3.865v35.237c0 2.685-1.179 3.93-3.864 3.93h-1.703v1.375h17.488v-1.375h-1.703c-2.62 0-3.865-1.245-3.865-3.93V23.587h1.245c4.847 0 7.597 3.537 10.676 9.497l2.161 4.192c1.834 3.537 2.947 6.091 4.257 8.842h9.432v-1.375c-2.031-.066-3.209-.983-4.126-2.882zm-19.584-19.976h-4.061V1.974h4.585c7.336 0 10.545 4.584 10.545 9.89 0 5.501-3.471 10.02-11.069 10.02z"
  }));
};
LogoIcon.defaultProps = {
  viewBox: "0 0 201 47",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var MinusIcon = function MinusIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.438h-13v-1.2h13v1.2z"
  }));
};
MinusIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlusIcon = function PlusIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.438h-13v-1.2h13v1.2z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 19.338v-13h1.2v13h-1.2z"
  }));
};
PlusIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowLeft = function ArrowLeft(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), __jsx("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
  }));
};
ArrowLeft.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var defaultProps = {
  logo: __jsx(LogoIcon, null)
};
var CookiesPanel = function CookiesPanel(props) {
  var buttonLight = props.buttonLight,
    button = props.button,
    checkboxSelectable = props.checkboxSelectable,
    showPanel = props.showPanel,
    verticalMenuWithContentToggle = props.verticalMenuWithContentToggle,
    setShowPanel = props.setShowPanel,
    domain = props.domain,
    _props$logo = props.logo,
    logo = _props$logo === void 0 ? defaultProps.logo : _props$logo;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var translations = {
    acceptAllCookies: (0, _langLibrary["default"])("Accept all cookies"),
    confirmSettings: (0, _langLibrary["default"])("Confirm my settings"),
    cookiesPanelTitle: (0, _langLibrary["default"])("Manage cookie settings"),
    active: (0, _langLibrary["default"])("Active"),
    cookieNotice: (0, _langLibrary["default"])("Cookie notice", {
      domain: domain
    }),
    accept: (0, _langLibrary["default"])("Accept"),
    requiredCookiesDescription: (0, _langLibrary["default"])("Required cookies description", {
      domain: domain
    }),
    analyticCookiesDescription: (0, _langLibrary["default"])("Analytic cookies description", {
      domain: domain
    }),
    trackingCookiesDescription: (0, _langLibrary["default"])("Tracking cookies description"),
    thirdPartyCookies: (0, _langLibrary["default"])("Third party cookies"),
    backToList: (0, _langLibrary["default"])("Back to cookie list"),
    showCookies: (0, _langLibrary["default"])("Show cookie list"),
    name: (0, _langLibrary["default"])("Cookie name"),
    duration: (0, _langLibrary["default"])("Duration"),
    type: (0, _langLibrary["default"])("Type"),
    necessary: (0, _langLibrary["default"])("Necessary cookies"),
    analytic: (0, _langLibrary["default"])("Analytic cookies"),
    tracking: (0, _langLibrary["default"])("Tracking cookies"),
    thirdParty: (0, _langLibrary["default"])("Third party"),
    own: (0, _langLibrary["default"])("Own"),
    day: (0, _langLibrary["default"])("day"),
    days: (0, _langLibrary["default"])("days"),
    years: (0, _langLibrary["default"])("years"),
    minute: (0, _langLibrary["default"])("minute"),
    minutes: (0, _langLibrary["default"])("minutes"),
    month: (0, _langLibrary["default"])("month"),
    months2: (0, _langLibrary["default"])("months2"),
    months: (0, _langLibrary["default"])("months"),
    year: (0, _langLibrary["default"])("year"),
    session: (0, _langLibrary["default"])("session"),
    hour: (0, _langLibrary["default"])("hour"),
    showMore: (0, _langLibrary["default"])("show more")
  };
  var _useCookieAgreements = (0, _CookieAgreementsProvider.useCookieAgreements)(),
    cookieAgreements = _useCookieAgreements.cookieAgreements,
    setCookieAgreements = _useCookieAgreements.setCookieAgreements,
    analyticsID = _useCookieAgreements.analyticsID,
    gtmID = _useCookieAgreements.gtmID,
    fbID = _useCookieAgreements.fbID;
  var _useState = (0, _react.useState)({
      analytic: false,
      tracking: false
    }),
    agreements = _useState[0],
    setAgreements = _useState[1];
  var setAgreementsState = function setAgreementsState(agreements) {
    setAgreements(agreements);
  };
  var setAgreementsFromState = function setAgreementsFromState() {
    var allTrue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var body = document.querySelector("body");
    body.style.removeProperty("overflow-y");
    body.style.removeProperty("padding-right");
    setShowPanel(false);
    (0, _setAgreementsCookie["default"])({
      language: language,
      agreements: allTrue ? allTrue : agreements,
      cookieAgreements: {
        setCookieAgreements: setCookieAgreements,
        analyticsID: analyticsID,
        gtmID: gtmID,
        fbID: fbID
      }
    });
  };
  var acceptAllCookiesButton = /*#__PURE__*/_react["default"].cloneElement(button, {
    onClick: function onClick() {
      return setAgreementsFromState(true);
    }
  }, translations.acceptAllCookies);
  var acceptMySettingsButton = /*#__PURE__*/_react["default"].cloneElement(buttonLight, {
    onClick: function onClick() {
      return setAgreementsFromState();
    }
  }, translations.confirmSettings);
  var menuLeft = [{
    label: translations.necessary,
    url: "necessary"
  }, {
    label: translations.analytic,
    url: "analytic"
  }, {
    label: translations.tracking,
    url: "tracking"
  }];
  var content = [{
    label: translations.necessary,
    id: "necessary",
    text: translations.requiredCookiesDescription,
    checkboxClickable: false
  }, {
    label: translations.analytic,
    id: "analytic",
    text: translations.analyticCookiesDescription,
    checkboxClickable: true
  }, {
    label: translations.tracking,
    id: "tracking",
    text: translations.trackingCookiesDescription,
    checkboxClickable: true
  }];
  var cookieList = {
    necessary: [{
      domain: language === null || language === void 0 ? void 0 : language.domain,
      cookies: [{
        name: "_gat_gtag_UA_2324611_1",
        duration: "1 " + translations.minute,
        type: translations.own
      }, {
        name: "PHPSESSID",
        duration: "2 " + translations.days,
        type: translations.thirdParty
      }, {
        name: "_ga",
        duration: "2 " + translations.years,
        type: translations.own
      }, {
        name: "_gcl_au",
        duration: "3 " + translations.months,
        type: translations.own
      }, {
        name: "_gid",
        duration: "1 " + translations.minute,
        type: translations.own
      }, {
        name: "_ga_25MSX90C1B",
        duration: "2 " + translations.years,
        type: translations.own
      }, {
        name: "_gat",
        duration: "1 " + translations.minute,
        type: translations.own
      }, {
        name: "_fbp",
        duration: "3 " + translations.months,
        type: translations.own
      }, {
        name: "__cfduid",
        duration: "28 " + translations.days,
        type: translations.own
      }, {
        name: "cartId",
        duration: translations.session,
        type: translations.own
      }, {
        name: "userAgreementCookie",
        duration: "2 " + translations.months,
        type: translations.own
      }]
    }],
    analytic: [{
      domain: "google.com",
      cookies: [{
        name: "1P_JAR",
        duration: "1 " + translations.month,
        type: translations.thirdParty
      }, {
        name: "CONSENT",
        duration: "17 " + translations.years,
        type: translations.thirdParty
      }, {
        name: "NID",
        duration: "6 " + translations.months2,
        type: translations.thirdParty
      }, {
        name: "DV",
        duration: "5 " + translations.minutes,
        type: translations.thirdParty
      }]
    }, {
      domain: "google.pl",
      cookies: [{
        name: "NID",
        duration: "6 " + translations.months2,
        type: translations.thirdParty
      }, {
        name: "CONSENT",
        duration: "17 " + translations.years,
        type: translations.thirdParty
      }]
    }, {
      domain: "doubleclick.net",
      cookies: [{
        name: "IDE",
        duration: "3 " + translations.months,
        type: translations.thirdParty
      }, {
        name: "DSID",
        duration: "14 " + translations.days,
        type: translations.thirdParty
      }, {
        name: "RUL",
        duration: "1 " + translations.year,
        type: translations.thirdParty
      }]
    }],
    tracking: [__webpack_require__.g.__appConfig__.facebookEnabled ? {
      domain: "facebook.com",
      cookies: [{
        name: "fr",
        duration: "3 " + translations.months,
        type: translations.thirdParty
      }]
    } : {}, (0, _isSalesmanagoEnabled["default"])({
      language: language.language
    }) ? {
      domain: "salesmanago.pl",
      cookies: [{
        name: "userId",
        duration: "1 " + translations.hour,
        type: translations.thirdParty
      }]
    } : {}]
  };
  cookieList.tracking = cookieList.tracking.filter(function (track) {
    return track === null || track === void 0 ? void 0 : track.domain;
  });
  var _useState2 = (0, _react.useState)(menuLeft && menuLeft[0].url),
    activeElement = _useState2[0],
    setActiveElement = _useState2[1];
  var _useState3 = (0, _react.useState)("none"),
    activeCookieList = _useState3[0],
    setActiveCookieList = _useState3[1];
  var onSideMenuClick = function onSideMenuClick(e) {
    setActiveElement(e.target.id);
  };
  var scrollbarStyles = {
    "::-webkit-scrollbar": {
      width: 7
    },
    "&::-webkit-scrollbar-thumb": {
      bg: "neutral900",
      borderRadius: 5,
      mx: 6
    },
    "::-webkit-scrollbar-track": {
      bg: "white"
    }
  };
  return __jsx(_react["default"].Fragment, null, __jsx(_reactModal["default"], {
    isOpen: showPanel // for test change to true
    ,
    style: {
      overlay: {
        backgroundColor: "rgba(0, 0, 0, 0)",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center"
      },
      content: {
        position: "static",
        width: 760,
        backgroundColor: "rgba(0, 0, 0, 0)",
        inset: 0,
        border: "none",
        padding: 0
      }
    }
  }, __jsx(_Box["default"], {
    sx: {
      backgroundColor: "white",
      width: ["100vw", null, 750],
      height: ["100vh", null, 610],
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      overflow: "hidden"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      height: [100, null, 75],
      display: "flex",
      flexDirection: ["column", null, "row"],
      alignItems: ["center", null, "auto"],
      borderBottomColor: "neutral",
      borderBottomStyle: "solid",
      borderBottomWidth: "1px",
      borderBottom: [null, null, "none"],
      mt: [25, null, 0]
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: [170, null, 200],
      py: 20,
      px: 30,
      pb: [10, null, 20],
      svg: {
        fill: "main"
      }
    }
  }, logo), __jsx(_Box["default"], {
    sx: {
      py: [0, null, 20],
      px: 30,
      font: "l",
      color: "main",
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box"
    }
  }, translations.cookiesPanelTitle)), Object.keys(cookieList).map(function (cookieType) {
    return __jsx(_Box["default"], {
      key: "cookieList-".concat(cookieType),
      id: "cookieList-".concat(cookieType),
      sx: {
        width: ["100%", 0, 750],
        height: ["calc(100vh - 119px)", null, 425],
        bg: "white",
        position: "absolute",
        top: [119, null, 75],
        boxSizing: "border-box",
        zIndex: 1,
        overflow: "hidden",
        display: activeCookieList === cookieType ? "block" : "none"
      }
    }, __jsx(_Box["default"], {
      sx: {
        borderWidth: 1,
        borderColor: "neutral500",
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "neutral500",
        borderBottomStyle: "solid",
        px: 20,
        py: 10,
        font: "body",
        color: "main",
        display: "flex",
        cursor: "pointer"
      },
      onClick: function onClick() {
        return setActiveCookieList("none");
      }
    }, __jsx(ArrowLeft, null), __jsx(_Box["default"], {
      sx: {
        ml: 10
      }
    }, translations.backToList)), __jsx(_Box["default"], {
      sx: _objectSpread({
        height: ["calc(100vh - 150px)", null, 375],
        overflow: "hidden",
        overflowY: "auto"
      }, scrollbarStyles)
    }, cookieList[cookieType].map(function (cookiesByDomain, index) {
      return __jsx(_Accordion["default"], {
        key: "accordion-".concat(cookiesByDomain.domain),
        sx: {
          mx: [0, null, 20],
          boxSizing: "border-box"
        }
      }, __jsx(_Accordion["default"].Section, {
        key: "accordionSection-".concat(cookiesByDomain.domain),
        isOpenAtInit: false
      }, __jsx(_Button["default"], {
        sx: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pt: 17,
          pb: 13,
          px: 10,
          width: "100%",
          color: "main",
          ":focus": {
            outline: 0,
            boxShadow: "none"
          },
          "::-moz-focus-inner": {
            border: 0
          }
        }
      }, function (_ref) {
        var selected = _ref.selected;
        return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
          sx: {
            font: "base_sans_bold"
          }
        }, cookiesByDomain.domain), __jsx(_Box["default"], {
          sx: {
            font: "xs",
            height: 24,
            display: "flex",
            alignItems: "center"
          }
        }, __jsx(_Box["default"], {
          sx: {
            height: 24,
            display: "flex",
            alignItems: "center"
          }
        }, translations.showCookies), selected ? __jsx(MinusIcon, null) : __jsx(PlusIcon, null)));
      }), __jsx(_ShowHide["default"], null, __jsx(_Box["default"], {
        sx: _objectSpread({
          height: cookieType === "tracking" && (index === 0 || index === 2) ? 120 : 320,
          overflow: "hidden",
          overflowY: "auto",
          p: "16px 0px",
          pt: 0,
          font: "body",
          color: "main"
        }, scrollbarStyles)
      }, cookiesByDomain.cookies.map(function (cookie) {
        return __jsx(_Box["default"], {
          key: "cookieDomain-" + cookie.name,
          sx: {
            bg: "neutral100",
            mb: 20,
            p: 20,
            font: "xs"
          }
        }, __jsx(_Box["default"], {
          sx: {
            display: "flex"
          }
        }, __jsx(_Box["default"], {
          key: "name-" + cookie.name,
          sx: {
            width: [90, null, 100]
          }
        }, translations.name), __jsx(_Box["default"], null, cookie.name)), __jsx(_Box["default"], {
          key: "domain-" + cookie.name,
          sx: {
            display: "flex"
          }
        }, __jsx(_Box["default"], {
          sx: {
            width: [90, null, 100]
          }
        }, "Host"), __jsx(_Box["default"], null, cookiesByDomain.domain)), __jsx(_Box["default"], {
          sx: {
            display: "flex"
          }
        }, __jsx(_Box["default"], {
          sx: {
            width: [90, null, 100]
          }
        }, translations.duration), __jsx(_Box["default"], null, cookie.duration)), __jsx(_Box["default"], {
          sx: {
            display: "flex"
          }
        }, __jsx(_Box["default"], {
          sx: {
            width: [90, null, 100]
          }
        }, translations.type), __jsx(_Box["default"], null, cookie.type)));
      })))), __jsx(_Box["default"], {
        sx: {
          height: "1px",
          bg: "neutral"
        }
      }));
    })));
  }), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: ["column", null, "row"],
      color: "main",
      height: ["calc(100vh - 310px)", null, 450]
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: ["100%", null, 200],
      mb: [30, null, 0]
    }
  }, __jsx(_Display["default"], {
    when: [false, null, true]
  }, __jsx(_SideStickyMenu["default"], {
    menuData: menuLeft,
    initialActiveRow: menuLeft.length > 0 && menuLeft[0].url,
    onClick: onSideMenuClick,
    resetPosition: true
  })), __jsx(_Display["default"], {
    when: [true, null, false]
  }, __jsx(_Box["default"], {
    sx: {
      height: "calc(100vh - 309px)",
      overflow: "scroll"
    }
  }, content.map(function (option, index) {
    return /*#__PURE__*/_react["default"].cloneElement(verticalMenuWithContentToggle, {
      key: option.label,
      label: option.label,
      element: option,
      initialOpen: index === 0,
      labelFont: false,
      textFont: false,
      setAgreementsState: setAgreementsState,
      agreements: agreements,
      setActiveCookieList: setActiveCookieList
    });
  })))), __jsx(_Box["default"], {
    sx: _objectSpread({
      width: ["100vw", null, 550],
      height: ["calc(100vh - 355px)", null, "auto"],
      overflow: "hidden",
      overflowY: ["scroll", null, "hidden"],
      px: 30,
      boxSizing: "border-box"
    }, scrollbarStyles)
  }, content.map(function (element) {
    return __jsx(_Box["default"], {
      key: element.label,
      sx: {
        display: element.id === activeElement ? "block" : "none"
      }
    }, __jsx(_Box["default"], {
      key: "label-".concat(element.label),
      sx: {
        font: "base",
        justifyContent: "space-between",
        display: "flex"
      }
    }, __jsx(_Box["default"], {
      sx: {
        width: 600
      }
    }, element.label), __jsx(_Box["default"], {
      sx: {
        width: 150
      },
      id: element.id,
      onClick: function onClick() {
        agreements[element.id] = !agreements[element.id];
        setAgreements(agreements);
      }
    }, __jsx(_Checkbox["default"], null, /*#__PURE__*/_react["default"].cloneElement(checkboxSelectable, {
      disabled: !element.checkboxClickable,
      label: translations.active
    })))), __jsx(_Box["default"], {
      sx: {
        font: "s",
        mt: 10
      }
    }, element.text, __jsx(_Box["default"], {
      sx: {
        mt: 20,
        font: "xs_underline",
        cursor: "pointer"
      },
      onClick: function onClick() {
        setActiveCookieList(element.id);
      }
    }, translations.thirdPartyCookies)), __jsx(_Box["default"], {
      sx: {
        font: "s",
        justifyContent: "space-between",
        display: "flex",
        mt: "s8",
        a: {
          display: "contents",
          color: "active"
        }
      },
      dangerouslySetInnerHTML: {
        __html: translations.cookieNotice
      }
    }));
  }))), __jsx(_Box["default"], {
    sx: {
      height: [160, null, 90],
      px: 20,
      py: 20,
      display: "flex",
      flexDirection: ["column", null, "row"],
      justifyContent: "space-between",
      borderTopWidth: 1,
      borderTopColor: "neutral500",
      borderTopStyle: "solid",
      alignSelf: "flex-bottom",
      mb: [35, null, 0]
    }
  }, acceptMySettingsButton, acceptAllCookiesButton))));
};
var _default = CookiesPanel;
exports.Z = _default;

/***/ }),

/***/ 95718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Display = _interopRequireDefault(__webpack_require__(35572));
var _Accordion = _interopRequireDefault(__webpack_require__(73650));
var _ButtonRaw = _interopRequireDefault(__webpack_require__(30650));
var _ShowHide = _interopRequireDefault(__webpack_require__(2500));
var _router = __webpack_require__(53746);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ChevronDownIcon = function ChevronDownIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
ChevronDownIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronUpIcon = function ChevronUpIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.35 8.07l6.42 6.42-.85.85-5.57-5.58-5.58 5.58-.85-.85z"
  }));
};
ChevronUpIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  resetPosition: false,
  button: __jsx(_ButtonRaw["default"], null),
  rowStyle: {
    px: "20px",
    py: "s7",
    font: "s_sans",
    borderWidth: "1px",
    borderStyle: "solid",
    borderBottomColor: "neutral",
    borderTopColor: "transparent",
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    boxSizing: "border-box",
    color: "main",
    width: "100%",
    ":focus": {
      outline: 0,
      boxShadow: "none"
    },
    "::-moz-focus-inner": {
      border: 0
    }
  },
  additionalActiveRowStyles: {
    font: "s_sans_bold",
    borderWidth: "1px",
    borderColor: "main"
  }
};
var SideStickyMenu = function SideStickyMenu(_ref) {
  var _menuData$find$label, _menuData$find;
  var menuData = _ref.menuData,
    initialActiveRow = _ref.initialActiveRow,
    _onClick = _ref.onClick,
    _ref$resetPosition = _ref.resetPosition,
    resetPosition = _ref$resetPosition === void 0 ? defaultProps.resetPosition : _ref$resetPosition,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? defaultProps.button : _ref$button,
    _ref$rowStyle = _ref.rowStyle,
    rowStyle = _ref$rowStyle === void 0 ? defaultProps.rowStyle : _ref$rowStyle,
    _ref$additionalActive = _ref.additionalActiveRowStyles,
    additionalActiveRowStyles = _ref$additionalActive === void 0 ? defaultProps.additionalActiveRowStyles : _ref$additionalActive;
  var router = (0, _router.useRouter)();
  var _useState = (0, _react.useState)(initialActiveRow),
    activeRow = _useState[0],
    setActiveRow = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    accordionOpen = _useState2[0],
    setAccordionOpen = _useState2[1];
  var activeStyle = _objectSpread(_objectSpread({}, rowStyle), additionalActiveRowStyles);
  var buttonStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  };
  var onMenuClick = function onMenuClick(url, urlType) {
    if (urlType === "local") {
      router.push("/info/" + url);
    } else {
      window.open(url, "_blank");
    }
  };
  var mobileMenuOptions = menuData === null || menuData === void 0 ? void 0 : menuData.map(function (menuRaw, index) {
    return menuRaw.url !== activeRow && /*#__PURE__*/_react["default"].cloneElement(button, {
      sx: rowStyle,
      id: menuRaw.url,
      onClick: function onClick(e) {
        _onClick ? _onClick(e) : onMenuClick(menuRaw.url, menuRaw.url_type);
        setActiveRow(menuRaw.url);
        setAccordionOpen(false);
      },
      key: index
    }, menuRaw.label);
  });
  return __jsx(_Box["default"], {
    sx: !resetPosition && {
      position: ["relative", null, "sticky", null],
      top: [0, null, "30vh", null],
      width: ["calc(100% + 10vw)", null, "318px", null],
      left: "-5vw"
    }
  }, __jsx(_Display["default"], {
    when: [true, null, false]
  }, __jsx(_Accordion["default"], null, __jsx(_Accordion["default"].Section, {
    isOpenAtInit: true
  }, /*#__PURE__*/_react["default"].cloneElement(button, {
    sx: {
      width: "100%",
      ":focus": {
        outline: 0,
        boxShadow: "none"
      },
      "::-moz-focus-inner": {
        border: 0
      }
    }
  }, __jsx(_Box["default"], {
    onClick: function onClick() {
      setAccordionOpen(!accordionOpen);
    },
    sx: accordionOpen ? _objectSpread(_objectSpread({}, buttonStyle), activeStyle) : _objectSpread(_objectSpread({}, buttonStyle), rowStyle)
  }, __jsx(_Box["default"], {
    sx: {
      font: "s_sans_bold"
    }
  }, (_menuData$find$label = menuData === null || menuData === void 0 ? void 0 : (_menuData$find = menuData.find(function (option) {
    if (option.url === activeRow) {
      return option;
    }
  })) === null || _menuData$find === void 0 ? void 0 : _menuData$find.label) !== null && _menuData$find$label !== void 0 ? _menuData$find$label : ""), __jsx(_Box["default"], null, accordionOpen ? __jsx(ChevronUpIcon, null) : __jsx(ChevronDownIcon, null)))), resetPosition ? __jsx(_Box["default"], {
    sx: {
      display: accordionOpen ? "block" : "none"
    }
  }, mobileMenuOptions) : __jsx(_ShowHide["default"], null, mobileMenuOptions)))), __jsx(_Display["default"], {
    when: [false, null, true]
  }, menuData.map(function (menuRaw, index) {
    return /*#__PURE__*/_react["default"].cloneElement(button, {
      sx: activeRow === menuRaw.url ? activeStyle : rowStyle,
      id: menuRaw.url,
      key: index,
      onClick: function onClick(e) {
        setActiveRow(menuRaw.url);
        if (_onClick) {
          _onClick(e);
        } else {
          setAccordionOpen(false);
          onMenuClick(menuRaw.url, menuRaw.url_type);
        }
      }
    }, menuRaw.label);
  })));
};
var _default = SideStickyMenu;
exports["default"] = _default;

/***/ }),

/***/ 79071:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Accordion = _interopRequireDefault(__webpack_require__(73650));
var _ShowHide = _interopRequireDefault(__webpack_require__(2500));
var _Button = _interopRequireDefault(__webpack_require__(96088));
var _Checkbox = _interopRequireDefault(__webpack_require__(7284));
var __jsx = _react["default"].createElement;
var ChevronDownIcon = function ChevronDownIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
ChevronDownIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronUpIcon = function ChevronUpIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.35 8.07l6.42 6.42-.85.85-5.57-5.58-5.58 5.58-.85-.85z"
  }));
};
ChevronUpIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var VerticalMenuWithContentToggle = function VerticalMenuWithContentToggle(props) {
  var label = props.label,
    element = props.element,
    initialOpen = props.initialOpen,
    setActiveCookieList = props.setActiveCookieList,
    setAgreementsState = props.setAgreementsState,
    agreements = props.agreements,
    checkboxSelectable = props.checkboxSelectable;
  var translations = {
    thirdPartyCookies: (0, _langLibrary["default"])("Third party cookies"),
    alwaysActive: (0, _langLibrary["default"])("Always active"),
    cookieNotice: (0, _langLibrary["default"])("Cookie notice")
  };
  return __jsx(_Accordion["default"], {
    sx: {
      minWidth: "100%"
    }
  }, __jsx(_Accordion["default"].Section, {
    isOpenAtInit: initialOpen
  }, __jsx(_Button["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      pt: 17,
      pb: 13,
      width: "100%",
      color: "main",
      px: 20,
      ":focus": {
        outline: 0,
        boxShadow: "none"
      },
      "::-moz-focus-inner": {
        border: 0
      }
    }
  }, function (_ref) {
    var selected = _ref.selected;
    return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
      sx: {
        font: "base_sans_bold"
      }
    }, label), __jsx(_Box["default"], null, selected ? __jsx(ChevronUpIcon, null) : __jsx(ChevronDownIcon, null)));
  }), __jsx(_ShowHide["default"], null, __jsx(_Box["default"], {
    key: element.label
  }, __jsx(_Box["default"], {
    key: "label-".concat("element.label"),
    sx: {
      font: "base",
      justifyContent: "space-between",
      display: "flex"
    }
  }), __jsx(_Box["default"], {
    sx: {
      font: "s",
      mt: 10,
      px: 20,
      pb: 20
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: 120,
      "float": "right",
      p: 15,
      textAlign: "center",
      color: "active",
      font: "s_sans_bold"
    },
    onClick: function onClick() {
      agreements[element.id] = !agreements[element.id];
      setAgreementsState(agreements);
    }
  }, element.checkboxClickable ? __jsx(_Checkbox["default"], {
    sx: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/_react["default"].cloneElement(checkboxSelectable, {
    label: " "
  })) : __jsx(_Box["default"], null, translations.alwaysActive)), element.text, __jsx(_Box["default"], {
    sx: {
      mt: 20,
      font: "xs_underline",
      cursor: "pointer"
    },
    onClick: function onClick() {
      setActiveCookieList(element.id);
    }
  }, translations.thirdPartyCookies), __jsx(_Box["default"], {
    sx: {
      font: "s",
      justifyContent: "space-between",
      display: "flex",
      mt: "s8",
      a: {
        display: "contents"
      }
    },
    dangerouslySetInnerHTML: {
      __html: translations.cookieNotice
    }
  }))))), __jsx(_Box["default"], {
    sx: {
      height: "1px",
      bg: "neutral"
    }
  }));
};
VerticalMenuWithContentToggle.defaultProps = {
  initialOpen: false
};
var _default = VerticalMenuWithContentToggle;
exports.Z = _default;

/***/ }),

/***/ 55419:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Checkbox = _interopRequireDefault(__webpack_require__(59799));
var _Checkmark = _interopRequireDefault(__webpack_require__(30136));
var _CheckmarkAlternative = _interopRequireDefault(__webpack_require__(7635));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Checkbox = function Checkbox(props) {
  var _props$alternativeSty = props.alternativeStyling,
    alternativeStyling = _props$alternativeSty === void 0 ? false : _props$alternativeSty;
  var check = alternativeStyling ? __jsx(_CheckmarkAlternative["default"], {
    sx: {
      pt: 5
    }
  }) : __jsx(_Checkmark["default"], {
    sx: {
      pt: 5
    }
  });
  var labelContainerStyle = alternativeStyling ? {
    pl: 8,
    pt: 2
  } : {
    pl: 8
  };
  return __jsx(_Checkbox["default"], (0, _extends2["default"])({}, props, {
    sx: function sx(_ref) {
      var selected = _ref.selected,
        disabled = _ref.disabled;
      return _objectSpread({
        $checkmark: check,
        $labelContainer: _objectSpread({}, labelContainerStyle),
        $label: {
          font: "body2",
          color: "main"
        },
        $description: {
          font: "body2",
          color: "neutral900"
        }
      }, props.sx);
    }
  }));
};
var _default = Checkbox;
exports.Z = _default;

/***/ }),

/***/ 30136:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Checkmark = _interopRequireDefault(__webpack_require__(22040));
var _excluded = ["color"];
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  color: "main"
};
var Checkmark = function Checkmark(props) {
  var _props$color = props.color,
    color = _props$color === void 0 ? defaultProps.color : _props$color,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return __jsx(_Checkmark["default"], (0, _extends2["default"])({}, restProps, {
    sx: function sx(_ref) {
      var selected = _ref.selected,
        disabled = _ref.disabled,
        invalid = _ref.invalid;
      return _objectSpread({
        bg: disabled ? "neutral100" : selected ? color : "white",
        transition: "all .1s",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: invalid ? "negative" : selected ? "transparent" : "neutral900",
        borderRadius: props.rounded ? 50 : 4,
        $icon: {
          color: disabled ? "neutral900" : "white"
        }
      }, props.sx);
    }
  }));
};
var _default = Checkmark;
exports["default"] = _default;

/***/ }),

/***/ 7635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Checkmark = _interopRequireDefault(__webpack_require__(22040));
var _excluded = ["color"];
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  color: "main"
};
var Checkmark = function Checkmark(props) {
  var _props$color = props.color,
    color = _props$color === void 0 ? defaultProps.color : _props$color,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return __jsx(_Checkmark["default"], (0, _extends2["default"])({}, restProps, {
    sx: function sx(_ref) {
      var selected = _ref.selected,
        disabled = _ref.disabled,
        invalid = _ref.invalid;
      return _objectSpread({
        bg: "white",
        transition: "all .1s",
        borderWidth: "1px",
        borderStyle: "solid",
        width: 24,
        height: 24,
        borderColor: invalid ? "negative" : selected ? "darkBlue" : "neutral",
        borderRadius: props.rounded ? 50 : 4,
        $icon: {
          size: 10,
          color: disabled ? "white" : selected ? "darkBlue" : "white"
        }
      }, props.sx);
    }
  }));
};
var _default = Checkmark;
exports["default"] = _default;

/***/ }),

/***/ 29207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_CookiesPanel; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../components-new/dist/CookiesPanel/index.js
var CookiesPanel = __webpack_require__(81545);
// EXTERNAL MODULE: ../components-new/dist/buttons/Button/index.js
var Button = __webpack_require__(51586);
// EXTERNAL MODULE: ./src/components/selectables/Checkbox/index.js
var Checkbox = __webpack_require__(41110);
// EXTERNAL MODULE: ../components-new/dist/VerticalMenuWithContentToggle/index.js
var VerticalMenuWithContentToggle = __webpack_require__(79071);
;// CONCATENATED MODULE: ./src/components/VerticalMenuWithContentToggle/index.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var VerticalMenuWithContentToggle_VerticalMenuWithContentToggle = function(props) {
    var propsExt = _objectSpread({}, props, {
        checkboxSelectable: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {})
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalMenuWithContentToggle/* default */.Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ var components_VerticalMenuWithContentToggle = (VerticalMenuWithContentToggle_VerticalMenuWithContentToggle);

;// CONCATENATED MODULE: ./src/components/CookiesPanel/index.js






function CookiesPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CookiesPanel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CookiesPanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CookiesPanel_CookiesPanel = function(props) {
    var propsExt = CookiesPanel_objectSpread({}, props, {
        verticalMenuWithContentToggle: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerticalMenuWithContentToggle, {}),
        checkboxSelectable: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {}),
        button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
            "data-test": "accept-cookies-button"
        }),
        buttonLight: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
            sx: {
                $outline: true
            }
        })
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesPanel/* default */.Z, CookiesPanel_objectSpread({}, propsExt)));
};
/* harmony default export */ var components_CookiesPanel = (CookiesPanel_CookiesPanel);


/***/ }),

/***/ 41110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_selectables_Checkbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55419);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Checkbox = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_selectables_Checkbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ })

}]);